import React from 'react';

const VARIANT_CLASS = {
  wide: 'max-w-7xl',
  detail: 'max-w-6xl',
  reading: 'max-w-4xl',
};

/**
 * @param {'wide'|'detail'|'reading'} variant
 */
export default function PageContainer({ variant = 'wide', className = '', children }) {
  const max = VARIANT_CLASS[variant] || VARIANT_CLASS.wide;
  return (
    <div className={`${max} mx-auto w-full min-w-0 px-4 ${className}`.trim()}>{children}</div>
  );
}
